import './App.css';
import { BrowserRouter as Router, Routes, Route, Navigate, useLocation } from 'react-router-dom';
import { useEffect } from 'react';
import { AuthProvider, useAuth } from './lib/auth';
import { Toaster } from './components/ui/sonner';
import redditPixel from './lib/tracking';
import Landing from './pages/Landing';
import Login from './pages/Login';
import Signup from './pages/Signup';
import ScanProgress from './pages/ScanProgress';
import LeadPreview from './pages/LeadPreview';
import Dashboard from './pages/Dashboard';
import Leads from './pages/Leads';
import LeadDetail from './pages/LeadDetail';
import Keywords from './pages/Keywords';
import Subreddits from './pages/Subreddits';
import Settings from './pages/Settings';
import Onboard from './pages/Onboard';
import Ops from './pages/Ops';
import OpsUserDetail from './pages/OpsUserDetail';
import OpsCoupons from './pages/OpsCoupons';
import OpsLogin from './pages/OpsLogin';
import Privacy from './pages/Privacy';
import Terms from './pages/Terms';
import VerifyEmail from './pages/VerifyEmail';
import ForgotPassword from './pages/ForgotPassword';
import PaymentSuccess from './pages/PaymentSuccess';

function ProtectedRoute({ children }) {
  const { user, loading } = useAuth();
  if (loading) return <div className="flex items-center justify-center min-h-screen"><div className="shimmer w-48 h-6 rounded"></div></div>;
  if (!user) return <Navigate to="/login" />;
  if (user.role === 'admin') return <Navigate to="/ops" />;
  // Block unverified users (except admin)
  if (user.email_verified === false) return <Navigate to="/verify-email" />;
  return children;
}

function OpsRoute({ children }) {
  const { user, loading } = useAuth();
  if (loading) return <div className="flex items-center justify-center min-h-screen"><div className="shimmer w-48 h-6 rounded"></div></div>;
  if (!user) return <Navigate to="/ops/login" />;
  if (user.role !== 'admin') return <Navigate to="/dashboard" />;
  return children;
}

function RouteTracker() {
  const location = useLocation();
  useEffect(() => { redditPixel.pageVisit(location.pathname); }, [location.pathname]);
  return null;
}

function App() {
  return (
    <AuthProvider>
      <Router>
        <RouteTracker />
        <Routes>
          <Route path="/" element={<Landing />} />
          <Route path="/login" element={<Login />} />
          <Route path="/signup" element={<Signup />} />
          <Route path="/scan" element={<ScanProgress />} />
          <Route path="/preview" element={<LeadPreview />} />
          <Route path="/verify-email" element={<VerifyEmail />} />
          <Route path="/forgot-password" element={<ForgotPassword />} />
          <Route path="/payment/success" element={<ProtectedRoute><PaymentSuccess /></ProtectedRoute>} />
          <Route path="/onboard" element={<ProtectedRoute><Onboard /></ProtectedRoute>} />
          <Route path="/dashboard" element={<ProtectedRoute><Dashboard /></ProtectedRoute>} />
          <Route path="/leads" element={<ProtectedRoute><Leads /></ProtectedRoute>} />
          <Route path="/leads/:leadId" element={<ProtectedRoute><LeadDetail /></ProtectedRoute>} />
          <Route path="/keywords" element={<ProtectedRoute><Keywords /></ProtectedRoute>} />
          <Route path="/subreddits" element={<ProtectedRoute><Subreddits /></ProtectedRoute>} />
          <Route path="/settings" element={<ProtectedRoute><Settings /></ProtectedRoute>} />
          <Route path="/ops/login" element={<OpsLogin />} />
          <Route path="/ops" element={<OpsRoute><Ops /></OpsRoute>} />
          <Route path="/ops/users/:userId" element={<OpsRoute><OpsUserDetail /></OpsRoute>} />
          <Route path="/ops/coupons" element={<OpsRoute><OpsCoupons /></OpsRoute>} />
          <Route path="/privacy" element={<Privacy />} />
          <Route path="/terms" element={<Terms />} />
          <Route path="*" element={<Navigate to="/" />} />
        </Routes>
      </Router>
      <Toaster position="top-right" />
    </AuthProvider>
  );
}

export default App;
